import React from "react";

import "./stylesPersonalInfo.css";

import EditIcon from "../../../assets/icons/ic_edit.svg";
import BronzeIcon from "../../../assets/icons/ic_bronze-status.svg";
import VerifiedIcon from "../../../assets/icons/ic_verified.svg";

function PersonalInfo() {
  return (
    <div className="personal-info-container">
      <div className="personal-info-header">
        <h2>Personal info</h2>
        <img src={EditIcon} alt="edit icon" />
      </div>
      <div className="personal-info-body">
        <div className="personal-info-row">
          <div className="personal-info">
            <p className="first">User ID</p>
            <p className="second">00000001</p>
          </div>
          <div className="personal-info">
            <p className="first">User name</p>
            <p className="second">LuckyPlayer</p>
          </div>
        </div>
        <div className="personal-info-row">
          <div className="personal-info">
            <p className="first">First Name</p>
            <p className="second">Jane</p>
          </div>
          <div className="personal-info">
            <p className="first">Last Name</p>
            <p className="second">Cooper</p>
          </div>
        </div>
        <div className="personal-info-row">
          <div className="personal-info">
            <p className="first">Email</p>
            <p className="second">lucky@example.com</p>
          </div>
          <div className="personal-info">
            <p className="first">Phone</p>
            <p className="second">+1 (202) 555-0143</p>
          </div>
        </div>
        <div className="personal-info-row">
          <div className="personal-info">
            <p className="first">Date of registration</p>
            <p className="second">
              Oct 05, 2024
              <span className="number-of-days">13 days</span>
            </p>
          </div>
          <div className="personal-info">
            <p className="first">Rank</p>
            <p className="badge-bettor">
              <img src={BronzeIcon} alt="bronze icon" />
              BRONZE BETTOR
            </p>
          </div>
        </div>
        <div className="personal-info-row">
          <div className="personal-info">
            <p className="first">Address</p>
            <p className="second w-200">
              75 Higuera St # 201 San Luis Obispo, CA 93401 USA
            </p>
          </div>
          <div className="personal-info">
            <p className="first">KYC</p>
            <p className="second">
              <img src={VerifiedIcon} alt="verified icon" />
              Verified
              <span className="number-of-days">Oct 05, 2024</span>
            </p>
          </div>
        </div>
      </div>
      <div className="personal-info-footer">
        <h2>Notes</h2>
        <button>Add Note</button>
      </div>
    </div>
  );
}

export default PersonalInfo;
